import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

import initHeader from './components/header';
import initLogos from './components/logos';
import initTexts from './components/texts';
import initPanel from './components/panel';
import initScheme from './components/scheme';
import initLoader from './components/loader';
import { prefersReducedMotion } from './utils/dom';

gsap.registerPlugin(ScrollTrigger);

// Styles
import '../scss/styles.scss';

// -----------------------------
// Lenis
// -----------------------------
const isTouch = matchMedia('(hover: none) and (pointer: coarse)').matches;

let lenis = null;
// Smooth scroll is motion the user can't opt out of per-element — skip it
// entirely when reduced motion is requested (native scrolling takes over).
if (!isTouch && !prefersReducedMotion()) {
  lenis = new Lenis({
    smoothWheel: true,
    duration: 1.2,
    easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
  });

  lenis.on('scroll', ScrollTrigger.update);
  gsap.ticker.add((time) => {
    lenis.raf(time * 1000);
  });
  gsap.ticker.lagSmoothing(0);
}
window.lenis = lenis;


// -----------------------------
// Helpers init
// -----------------------------

function initPage() {
  initHeader();
  initLogos();
  initTexts();
  initPanel();
  initScheme();
  initLoader();

  const imgAnim = document.querySelector('.img-anim');
  if (imgAnim) {
    imgAnim.classList.add('show');
  }
}


function afterPageMounted() {

  if (lenis) {
    lenis.resize();
    try {
      lenis.scrollTo(0, { immediate: true });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  } else {
    window.scrollTo(0, 0);
  }

  // Refresh ScrollTrigger to account for new page layout
  ScrollTrigger.refresh();
}

addEventListener("DOMContentLoaded", () => {
  // Wait for fonts before running SplitText (line breaks depend on final font metrics)
  document.fonts.ready.then(() => {
    initPage();
    afterPageMounted();

    // Fade out the white page overlay (remove instantly under reduced motion)
    const overlay = document.querySelector('.page-overlay');
    if (overlay) {
      if (prefersReducedMotion()) {
        overlay.remove();
      } else {
        gsap.to(overlay, {
          opacity: 0,
          duration: 0.1,
          ease: 'power2.out',
          onComplete: () => overlay.remove(),
        });
      }
    }
  });
})
